import { StyleSheet } from 'react-native';

import { Colors } from '../Themes';

export default StyleSheet.create({
  primaryButtonStyle: (theme, disabled) => ({
    alignItems: 'center',
    backgroundColor: disabled
      ? theme.colors.buttons.disabledTwo
      : theme.colors.buttons.primary.default,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  primaryTextStyle: theme => ({
    color: theme.colors.textButtons.primary.default,
    fontSize: 16,
    textAlign: 'center',
  }),
  primaryWhiteButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.primaryWhite.default,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  primaryWhiteTextStyle: theme => ({
    color: theme.colors.textButtons.primaryWhite.default,
    fontSize: 16,
    textAlign: 'center',
  }),
  secondaryButtonStyle: (theme, disabled) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.secondary.default,
    borderColor: theme.colors.buttons.secondary.borderColor,
    opacity: disabled ? 0.38 : 1,
    borderWidth: 2,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  secondaryTextStyle: theme => ({
    color: theme.colors.textButtons.secondary.default,
    fontSize: 16,
    textAlign: 'center',
  }),
  tertiaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.tertiary.default,
    borderRadius: 6,
    borderColor: Colors.light_grey,
    borderWidth: 1,
    height: 44,
    justifyContent: 'center',
  }),
  tertiaryTextStyle: theme => ({
    color: theme.colors.textButtons.tertiary.default,
    fontSize: 16,
    textAlign: 'center',
  }),
  quaternaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.quaternary.default,
    borderColor: theme.colors.buttons.quaternary.borderColor,
    borderWidth: 1,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  quaternaryTextStyle: theme => ({
    color: theme.colors.textButtons.quaternary.default,
    fontSize: 16,
    textAlign: 'center',
  }),
  quinaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.quinary.default,
    borderColor: theme.colors.buttons.quinary.borderColor,
    borderWidth: 1,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  quinaryTextStyle: theme => ({
    color: theme.colors.textButtons.quinary.default,
    fontSize: 16,
    textAlign: 'center',
  }),
  hoveredButton: {
    borderWidth: 0,
  },
  hoveredText: theme => ({
    color: theme.colors.textButtons.primary.default,
  }),
  buttonStyle: {
    flexDirection: 'row',
  },
});
export const underlayColor = theme => ({
  primary: theme.colors.buttons.primary.active,
  primaryWhite: theme.colors.buttons.primaryWhite.active,
  secondary: theme.colors.buttons.secondary.active,
  tertiary: theme.colors.buttons.tertiary.active,
  quaternary: theme.colors.buttons.quaternary.active,
  quinary: theme.colors.buttons.quinary.active,
});
